<template>
  <div :class="activeSection ? 'panel-wrapper' : 'panel-wrapper panel-unactive'">
    <div class="section-header">
      <div ref="sectionProgress" class="circular-progress-container" :style="progressBarCss" :class="isSectionComplete?'section-complete':''">
        <div class="circle">
          <div class="mask full">
            <div class="fill" />
          </div>
          <div class="mask half">
            <div class="fill" />
          </div>
          <div class="inside-circle">
            {{ displayId }}
          </div>
        </div>
      </div>
      <div class="section-title">
        <div>{{ sectionTitle }}</div>
        <KYCTag v-if="isKYCSection && currentKYCStatus !== null" :status="currentKYCStatus" />
      </div>
      <span class="arrow" @click="toggleSection">
        <img v-if="isSectionVisible" class="arrow-icon" src="@assets/images/caret_up.svg">
        <img v-else class="arrow-icon" src="@assets/images/caret_down.svg">
      </span>
    </div>
    <sb-accordion :is-visible="isSectionVisible" is-without-transition>
      <div class="section-content">
        <div
          v-for="(step, index) of steps"
          :id="$t(getDivId(step))"
          :key="index"
          style="display: contents"
        >
          <div v-if="index != 0" class="section-divider" />
          <KYCDescription
            v-if="isKYCSection && currentKYCStatus !== null"
            :status="currentKYCStatus"
            :attempts="kycAttempts"
            @cta-clicked="triggerKYCStatusCTA()"
          />
          <div v-else class="section-step-row">
            <div class="section-step-check">
              <circle-checkmark-icon v-if="step.IsCompleted" variation="complete" />
              <div v-else class="not-cmp" />
            </div>
            <div class="section-step-text">
              <div class="section-step-title">
                {{ $t(getContent(step)) }}
              </div>
              <div class="section-step-description">
                {{ $t(getDescription(step)) }}
                <a
                  v-if="step.HrefSecondary != ''"
                  :href="getHref(step.HrefSecondary, step.IsLegacyHrefSecondary)"
                  @click.prevent="clickItem(step.HrefSecondary, step.IsLegacyHrefSecondary)"
                >{{ $t(getSecondaryDescription(step)) }}</a>
              </div>
            </div>
            <sb-button
              v-if="!isKYCSection"
              :disabled="GetStartedStepsEnum.SendInventory === step.ItemId && !isKYCApproved"
              class="section-step-button"
              @click.prevent="clickItem(step.Href, step.IsLegacyHref, step.ItemId)"
            >
              {{ $t(getButtonText(step)) }}
            </sb-button>
            <div v-if="GetStartedStepsEnum.SendInventory === step.ItemId && isKYCApproved && !hasCreateWROPerm" class="kyc-banner">
              <KYCBanner />
            </div>
          </div>
          <KYCFooter v-if="isKYCSection" class="section-step-row-footer" />
        </div>
      </div>
    </sb-accordion>
  </div>
</template>
<script>
import GetStartedStepsEnum from '@/enums/modules/setup/getStartedSteps'
import getStartedSectionsEnum from '@/enums/modules/setup/getStartedSections'
import KYCStatus from '@/enums/modules/setup/KYCStatus'
import SbAccordion from '@/components/utils/SbAccordion'
import KYCFooter from './KYC/Footer'
import KYCTag from './KYC/Tag'
import KYCDescription from './KYC/Description'
import KYCWatcher from '@/mixins/KYCWatcher'
import KYCBanner from './KYC/Banner'

export default {
  name: 'GetStartedSetupSectionPanel',
  components: {
    SbAccordion,
    KYCFooter,
    KYCTag,
    KYCDescription,
    KYCBanner
  },
  mixins: [KYCWatcher],
  props: {
    displayId: {
      type: Number,
      required: true
    },
    sectionId: {
      type: Number,
      required: true
    },
    sectionTitle: {
      type: String,
      required: true
    },
    steps: {
      type: Array,
      required: true
    },
    activeSection: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      sectionVisible: undefined,
      GetStartedStepsEnum
    }
  },
  computed: {
    isKYCSection () {
      return this.sectionId === getStartedSectionsEnum.KYC
    },
    showKYCButton () {
      return this.currentKYCStatus === KYCStatus.Created
    },
    user () {
      return this.$shipBobStore.getters['user/getUser']
    },
    impersonatedUserId () {
      return this.user.impersonatedUserId
    },
    getStartedSections () {
      return this.$shipBobStore.getters['setupDashboard/getStartedSections']
    },
    progressBarCss () {
      const progressRatio = (this.steps.filter(step => step.IsCompleted === true).length / this.steps.length)
      const progress = 360 * progressRatio
      return {
        '--circular-progress': progress / 2 + 'deg'
      }
    },
    isSectionComplete () {
      return !this.steps.some(step => step.IsCompleted === false)
    },
    isSectionVisible: {
      get () {
        if (this.sectionVisible !== undefined) return this.sectionVisible
        const storage = window.localStorage.getItem(`GetStartedSectionAccordion-${this.impersonatedUserId}-${this.sectionId}`)
        if (this.isSectionComplete) {
          return false
        } else if (this.activeSection) {
          return true
        } else {
          return storage === 'true'
        }
      },
      set (value) {
        this.sectionVisible = value
      }
    }
  },
  methods: {
    getDivId (step) {
      return 'Step' + step.ItemId + '.DivId'
    },
    getContent (step) {
      return 'Step' + step.ItemId + '.Content'
    },
    getDescription (step) {
      return 'Step' + step.ItemId + '.Description'
    },
    getSecondaryDescription (step) {
      return 'Step' + step.ItemId + '.SecondaryLink'
    },
    getButtonText (step) {
      return 'Step' + step.ItemId + '.BottonText'
    },
    getHref (Href, IsLegacyHref) {
      if (Href) {
        if (IsLegacyHref) {
          return Href
        } else {
          return `/app/merchant/#/${Href}`
        }
      }
    },
    clickItem (Href, IsLegacyHref, itemId) {
      if (Href) {
        if (IsLegacyHref) {
          window.location.href = Href
        } else {
          this.$router.push({ path: Href })
        }
      }
    },
    dispatchStoreStepComplete (ItemId) {
      this.$shipBobStore.dispatch('setupDashboard/setGetStartedStep', { ItemId, IsCompleted: true })
    },
    toggleSection () {
      const newVal = !this.isSectionVisible
      this.isSectionVisible = newVal
      window.localStorage.setItem(`GetStartedSectionAccordion-${this.impersonatedUserId}-${this.sectionId}`, newVal)
    }
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'Welcome,',
        SubHeader: 'Let\'s get you set up. Follow these steps to get started:',
        ['Step' + GetStartedStepsEnum.KYC]: {
          Content: 'Verify your business',
          Description: '',
          SecondaryLink: '',
          BottonText: 'Get Started',
          Footer: KYCFooter
        },
        ['Step' + GetStartedStepsEnum.ConfigureProductPreference]: {
          Content: 'Configure Product Details',
          Description: 'Give us all of the information we need to ship your products.',
          BottonText: 'Configure Products'
        },
        ['Step' + GetStartedStepsEnum.ConfigureShippingPreference]: {
          Content: 'Verify Shipping Preferences',
          Description: 'Make sure your shipping speed(s) within ShipBob match your shipping options at checkout.',
          BottonText: 'Set Ship Mapping'
        },
        ['Step' + GetStartedStepsEnum.SendInventory]: {
          Content: 'Send Us Your Inventory',
          Description: 'Submit a WRO (Warehouse Receiving Order) and send us your inventory.',
          BottonText: 'Send Inventory'
        },
        ['Step' + GetStartedStepsEnum.ConfigureBilling]: {
          Content: 'Set Up Billing',
          Description: 'Enter a payment method so we can receive your inventory.',
          BottonText: 'Add Payment Method'
        },
        ['Step' + GetStartedStepsEnum.AddYourProducts]: {
          Content: 'Add Your Products',
          Description: 'Integrate your ecommerce platform with ShipBob to sync your products, or ',
          SecondaryLink: 'add products manually.',
          BottonText: 'Integrate a Store'
        },
        ['Step' + GetStartedStepsEnum.ImportOrders]: {
          Content: 'Import Orders',
          Description: 'Once your orders are imported and we have your inventory, we’ll start shipping! You can also ',
          SecondaryLink: 'enter orders manually.',
          BottonText: 'Import Orders'
        }
      }
    }
  }
}

</script>
<style scoped lang='scss'>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_setup-panel-get-startedV2.scss';
</style>
